import React from 'react';
import { useNavigate } from 'react-router-dom';

// Your image imports
import img0 from "../Assets/150.png";
import img1 from "../Assets/200.png";
import img2 from "../Assets/201.jpg";
import img3 from "../Assets/202.jpeg";
import img4 from "../Assets/203.jpg";
import img5 from "../Assets/204.jpg";

const ServiceCard = ({ title, image, description, lookup, onNavigate }) => (
    <div className="shadow-2xl hover:scale-105 bg-white transition-transform duration-300 rounded-xl text-center p-6">
        <h4 className='font-bold text-2xl md:text-3xl mb-4'>{title}</h4>
        <div className="flex justify-center mb-4">
            <img src={image} className="w-[70%] h-48 object-cover rounded-lg" alt={title} />
        </div>
        <p className='text-gray-600 mb-6 px-4 h-24 overflow-hidden'>
            {description}
        </p>
        <button 
            onClick={() => onNavigate(lookup)}  // Use the lookup prop for navigation
            className='bg-[#235951] text-white px-6 py-3 rounded-md font-bold hover:bg-[#1d4b45] transition-colors duration-300'
        >
            Know More
        </button>
    </div>
);


const Plans = () => {
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
        window.scrollTo(0, 0); // Scroll to top after navigation
    };

    const services = [
        {
            title: "Patent Innovation Incubation Service",
            image: img0,
            description: "Patent incubation services are designed to help inventors, entrepreneurs, and businesses develop, protect, and commercialize their intellectual property (IP).",
            lookup: "/services/Patents", 
        },
        {
            title: "Patent Services",
            image: img1,
            description: "Protect your inventions and innovations with our comprehensive patent services. We guide you through the entire process, from patent search to filing and prosecution.",
            lookup: "/services/Patents",
        },
        {
            title: "Trademark Services",
            image: img2,
            description: "Safeguard your brand identity with our trademark services. We handle trademark searches, registration, and enforcement to protect your valuable business assets.",
            lookup: "/services/Trademark", // Update to the correct hash
        },
        {
            title: "Copyright",
            image: img3,
            description: "Secure your creative works with our copyright services. We assist in registering and protecting your original literary, musical, dramatic, and artistic creations.",
            lookup: "/services/Copyright", // Update to the correct hash
        },
        {
            title: "Design Registration",
            image: img4,
            description: "Design registration service offers legal protection to the unique visual aspects of a product or its packaging, ensuring that the appearance, shape, configuration, pattern, or ornamentation of a design is safeguarded from unauthorized copying or imitation. This service helps businesses and individuals secure exclusive rights to their innovative designs, enhancing brand identity and market competitiveness. Through the design registration process, the originality and aesthetic value of a product are preserved, allowing owners to take legal action against infringements and build a strong, protected brand presence in the marketplace.",
            lookup: "/services/Design%20Registration", // Update to the correct hash
        },
        {
            title: "Civil Matters",
            image: img5,
            description: "Navigate complex civil litigation with our experienced team. We represent clients in various disputes, including contract, property, and tort cases.",
            lookup: "/services/Civil%20Matters", // Update to the correct hash
        }
    ];

    return (
        <div className='pt-[70px] bg-gradient-to-b from-[#235951] to-[#3F6D66]' id="services">
            <h1 className='text-center text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-600 via-yellow-500 to-amber-500 mb-2 drop-shadow-lg'>
                Services We Offer
            </h1>
            <div className="max-w-[1240px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-8">
                {services.map((service, index) => (
                    <ServiceCard key={index} {...service} onNavigate={handleNavigation} />
                ))}
            </div>
        </div>
    );
};

export default Plans;
